export default function () {
    this.loadChart()
}
